import { useCallback, useEffect, useState } from 'react';

import { LAYOUT_BREAKPOINTS } from '../config';

const COARSE_POINTER_QUERY = '(pointer: coarse)';

const getIsCoarsePointer = () => typeof window !== 'undefined' && window.matchMedia?.(COARSE_POINTER_QUERY).matches;

const useLayoutMode = () => {
  const [rootNode, setRootNode] = useState(null);
  const [width, setWidth] = useState(0);
  const [isCoarsePointer, setIsCoarsePointer] = useState(getIsCoarsePointer);

  const rootRef = useCallback((node) => {
    setRootNode(node);
  }, []);

  useEffect(() => {
    if (!rootNode) {
      return undefined;
    }
    const updateWidth = () => setWidth(rootNode.clientWidth);
    updateWidth();
    const observer = new ResizeObserver(updateWidth);
    observer.observe(rootNode);
    return () => observer.disconnect();
  }, [rootNode]);

  useEffect(() => {
    const query = window.matchMedia?.(COARSE_POINTER_QUERY);
    if (!query) {
      return undefined;
    }
    const handleChange = (event) => setIsCoarsePointer(event.matches);
    query.addEventListener('change', handleChange);
    return () => query.removeEventListener('change', handleChange);
  }, []);

  const isMeasured = width > 0;

  return {
    rootRef,
    isCoarsePointer,
    isTablet: isMeasured && width <= LAYOUT_BREAKPOINTS.TABLET,
    isCompact: isMeasured && width <= LAYOUT_BREAKPOINTS.COMPACT,
    isMobile: isMeasured && width <= LAYOUT_BREAKPOINTS.MOBILE,
  };
};

export default useLayoutMode;
